import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { SocketProvider } from "./shared/SocketContext";
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SocketProvider>
    <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
            <Toaster
              toastOptions={{
                className: "",
                style: {
                  border: `1px solid red`,
                  color: "#7d18d2",
                  fontSize: "15px",
                  marginTop: "100px",
                  borderRadius: "50px",
                  // background: "#7d18d2",
                },
              }}
            />
          </BrowserRouter>
    </QueryClientProvider>
  </SocketProvider>
);
reportWebVitals();
